import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Button as WCButton } from '@cuemath/web-comps';

const Button = styled(WCButton)`
  width: 400px;
  height: 48px;
`;

const CSUtils = () => {
  const history = useHistory();

  return (
    <div>
      <Button
        label="Chatbot Admin"
        size="small"
        onClick={() => history.push('/chatbot/')}
      />
      <Button
        label="Swap Phones"
        size="small"
        onClick={() =>
          window.open('https://admin.cuemath.com/auth/swap-phone/', '_blank')
        }
      />
      <Button
        label="Clawback Rewards admin"
        size="small"
        onClick={() =>
          window.open('https://admin.cuemath.com/teacher/admin/teacherrewards/', '_blank')
        }
      />
      <Button
        label="Create Teacher Reward admin"
        size="small"
        onClick={() =>
          window.open(
            'https://admin.cuemath.com/teacher/admin/createteacherrewardview/',
            '_blank',
          )
        }
      />
      <Button
        label="Add class benefits admin"
        size="small"
        onClick={() =>
          window.open(
            'https://admin.cuemath.com/intelenrollment/admin/addclassbenefitsview/',
            '_blank',
          )
        }
      />
    </div>
  );
};

export default CSUtils;
